import { useState, useEffect, useContext } from "react";
import NumberFormat from "react-number-format";
import { Link, useNavigate } from "react-router-dom";

import { Card, Badge } from "@mui/material";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";

import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import PageviewIcon from "@mui/icons-material/Pageview";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiAvatar from "components/SuiAvatar";
import SuiButton from "components/SuiButton";

import ChatRoom from "pages/messages/chatroom";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import AvatarComplex from "pages/de/share-page/components/AvatarComplex";

import api from "services/api";

import toast from "react-hot-toast";
import CategoryContext from "context/category-context";

import { compare } from "utils/helper";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

import StyleThumbnail from "pages/de/share-page/components/StyleThumbnail";
import { filterParser } from "utils/helper";

const avatarSize = 24;

const PublishProjectBar = ({ project, onPublish }) => {
  const [selectedUsers, setSelectedUsers] = useState([]);

  const navigate = useNavigate();

  const styles = project?.products || [];
  useEffect(() => {
    retrieveSelectedManufacturers();
  }, []);

  const retrieveSelectedManufacturers = async () => {
    // const { data } = await api.manufacturer.list({ offset, limit: pageSize });
    const payload = {
      offset: 0,
      limit: 100,
      q: "",
      sort: ["account_status:asc", "profile_update_level:desc"],
    };

    let myFilter = { account_type: "ma" };

    //filter out selected audiences
    if (project?.audiences && project.audiences.length > 0) {
      myFilter["id"] = { eq: project.audiences };
    }

    const newFilterStr = filterParser(myFilter);
    if (newFilterStr) {
      payload["filter"] = newFilterStr;
    }
    const { data } = await api.users.search(payload);
    setSelectedUsers(data ? data?.hits : []);
  };

  const onAvatarClick = (e, user) => {};

  return (
    <Card sx={{ px: 2, my: 1 }}>
      <SuiBox
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ height: "100%", minHeight: 60 }}
      >
        <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={5}>
          <SuiButton variant="text" color="dark" onClick={() => navigate(-1)} size="large">
            <ArrowBackIcon fontSize="sm" sx={{ mr: 0.5 }} /> Back
          </SuiButton>
          <SuiBox>
            <SuiTypography variant="h6">
              Project:{" "}
              <SuiTypography
                variant="body1"
                component={Link}
                to={`/produce/all-projects?id=${project.id}`}
              >
                {project.name}
              </SuiTypography>
            </SuiTypography>
          </SuiBox>
          <SuiBox>
            <SuiTypography variant="h6">
              Styles:{" "}
              <SuiTypography component="span" variant="body1">
                {" "}
                {styles.length}
              </SuiTypography>
            </SuiTypography>
          </SuiBox>
          <SuiBox>
            <SuiBox>
              <SuiBox
                sx={{ overflowX: "auto", py: 1 }}
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
              >
                {styles.map((item) => (
                  <Link to={`/workspace/styles-master?id=${item.id}`}>
                    <Tooltip title={item.title}>
                      <StyleThumbnail product={item} hideTitle />
                    </Tooltip>
                  </Link>
                ))}
              </SuiBox>
            </SuiBox>
          </SuiBox>
        </SuiBox>
        {project?.audiences?.length > 0 ? (
          <SuiBox display="flex" alignItems="center">
            <SuiTypography variant="h6">
              Sent Requests:{" "}
              <SuiTypography component="span" variant="body1">
                {" "}
                {project.audiences.length}
              </SuiTypography>
            </SuiTypography>
            <AvatarGroup
              max={project.audiences.length}
              sx={{ pl: 2, display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              {selectedUsers.map((user, index) => {
                const store = user?.stores && user?.stores.length > 0 ? user?.stores[0] : {};
                const maxAvatar = project.audiences.length;
                return (
                  <div>
                    <AvatarComplex
                      user={{ user: user }}
                      size="sm"
                      onAvatarClick={(e) => onAvatarClick(e, user)}
                      sx={{
                        cursor: "pointer",
                        py: 0.5,

                        "&:hover, &:focus": {
                          zIndex: "10",
                          pl: 2,
                          pr: index == Math.min(maxAvatar, selectedUsers.length) - 1 ? 0 : 2,
                        },
                        ml: -1.5,
                      }}
                      sharedSessions={null}
                      tooltip={`${store?.name}`}
                    />
                  </div>
                );
              })}
            </AvatarGroup>
          </SuiBox>
        ) : null}
      </SuiBox>
    </Card>
  );
};

export default PublishProjectBar;
